import Flickity from 'flickity-fade';
import EventHandler from '@pixelunion/events';
import Sidebar from '../components/Sidebar';

import ProductThumbnail from '../components/ProductThumbnail';

export default class FeaturedCollection {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.events = new EventHandler();

    this.productThumbnailsElements = this.el.querySelectorAll('[data-product-thumbnail]');
    this.collectionSlider = this.el.querySelector('[data-collection-slideshow]');

    this.productsPerRow = this.settings.products_per_row;
    this.productLimit = this.settings.products_limit;

    this.productThumbnails = [];
    const thumbnailSettings = {
      showSecondaryMediaOnHover: this.settings.show_secondary_media,
    };

    this.productThumbnailsElements.forEach(productThumbnail => {
      this.productThumbnails.push(new ProductThumbnail(productThumbnail, thumbnailSettings));
    });

    this.sidebar = new Sidebar(this.el);

    const toggleSlider = this.productLimit >= this.productsPerRow;

    if (this.collectionSlider && this.productsPerRow < this.productThumbnailsElements.length) {
      this.flickity = new Flickity(this.collectionSlider, {
        wrapAround: true,
        pageDots: false,
        cellAlign: 'left',
        adaptiveHeight: false,
        watchCSS: true,
        draggable: toggleSlider,
        prevNextButtons: toggleSlider,
        imagesLoaded: true,
      });

      this._updateTabindex();

      this.flickity.on('change', () => {
        this._updateTabindex();
      });

      if (toggleSlider === false) {
        this.isDraggable();
        this.events.register(window, 'resize', () => {
          this.isDraggable();
        });
      }
    }
  }

  isDraggable() {
    if (this.viewportIsMobile()) {
      this.flickity.options.draggable = true;
      this.flickity.updateDraggable();
    } else {
      this.flickity.options.draggable = false;
      this.flickity.updateDraggable();
    }
  }

  _updateTabindex() {
    // We need to remove tabindex from the slides that are not currently
    // selected, so that slides not currently shown cannot receive keyboard focus.
    const { selectedIndex } = this.flickity;

    for (let i = 0; i < this.productThumbnailsElements.length; i++) {
      const links = this.productThumbnailsElements[i].querySelectorAll('a');
      const isVisible = i >= selectedIndex && i < selectedIndex + this.productsPerRow;

      this.productThumbnailsElements[i].setAttribute('aria-hidden', isVisible ? 'false' : 'true');

      for (let j = 0; j < links.length; j++) {
        links[j].setAttribute('tabindex', isVisible ? '0' : '-1');
      }
    }
  }

  viewportIsMobile() {
    return window.innerWidth < 768;
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this.sidebar.unload();
    this.flickity.destroy();
    this.productThumbnails.forEach(productThumbnail => productThumbnail.unload());
  }
}
